import { render } from "./WikiItem.vue?vue&type=template&id=5fd3f25a"
import script from "./WikiItem.vue?vue&type=script&lang=js"
export * from "./WikiItem.vue?vue&type=script&lang=js"

import "./WikiItem.vue?vue&type=style&index=0&id=5fd3f25a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__